module.exports = __webpack_public_path__ + "img/positive.efebe50c.svg";